import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { FAQ_ITEMS } from "../constants/site";

export const Faq = () => {
    const [open, setOpen] = useState(0);

    return (
        <section id="faq" className="py-20 md:py-28" data-testid="faq-section">
            <div className="mx-auto max-w-3xl px-5 md:px-8">
                <Reveal className="text-center">
                    <Eyebrow>FAQ</Eyebrow>
                    <h2 className="mt-5 text-3xl font-bold text-white sm:text-4xl">
                        Perguntas frequentes
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-[#94A3B8] md:text-lg">
                        Ficou com alguma dúvida? Chama a gente no WhatsApp que
                        respondemos rapidinho.
                    </p>
                </Reveal>

                <div className="mt-12 space-y-3">
                    {FAQ_ITEMS.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={item.q} delay={i * 0.05}>
                                <div
                                    className={`overflow-hidden rounded-2xl border bg-[#0E0E14] transition-all duration-300 ${
                                        isOpen
                                            ? "border-[#E50914]/50 shadow-[0_0_35px_rgba(229,9,20,0.12)]"
                                            : "border-[#222232]"
                                    }`}
                                >
                                    <button
                                        data-testid={`faq-item-${i}`}
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                                        aria-expanded={isOpen}
                                    >
                                        <span className="font-display text-base font-bold text-white md:text-lg">
                                            {item.q}
                                        </span>
                                        <span
                                            className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-all duration-300 ${
                                                isOpen
                                                    ? "rotate-180 bg-[#E50914] text-white"
                                                    : "border border-[#222232] bg-[#14141E] text-[#94A3B8]"
                                            }`}
                                        >
                                            <ChevronDown className="h-4 w-4" />
                                        </span>
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{
                                                    duration: 0.35,
                                                    ease: [0.16, 1, 0.3, 1],
                                                }}
                                            >
                                                <p className="px-6 pb-6 text-sm leading-relaxed text-[#94A3B8] md:text-base">
                                                    {item.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
